export default __webpack_public_path__ + "assets/audio/ssml/audio.70e3b4b2afd3c560b88faa7ae54a1b65.mp3";